<template>
    <div style="margin-top: 24px;">
        <!-- <div style="font-size: 32px; font-weight: 700; line-height: 46px; text-align: center;">사커하우에 오신 이유를<br>알려주세요</div> -->
        <div>
            <div style="margin-top: 32px;">
                <div class="title">축구선수가 되기</div>
                <div class="common_box_wrap">
                    <div v-for="each, i in course" :key="i + 'course'" @click='setSelectPurpose(each.id, each.group_idx)' :style="{ backgroundColor: each.id === selectedPurpose ? 'var(--color-main)' : '#fff' }" class="common_box">
                        <div class="common_text">{{ each.title }}</div>
                    </div>
                </div>
            </div>
            <div style="margin-top: 32px;">
                <div class="title">축구 배우기</div>
                <div class="common_box_wrap">
                    <div v-for="each, i in lesson" :key="i + 'lesson'" @click='setSelectPurpose(each.id, each.group_idx)' :style="{ backgroundColor: each.id === selectedPurpose ? 'var(--color-main)' : '#fff' }" class="common_box">
                        <div class="common_text">{{ each.title }}</div>
                    </div>
                </div>
            </div>
            <div style="margin-top: 20px;">
                <div class="title">취미</div>
                <div class="common_box_wrap">
                    <div v-for="each, i in hobby" :key="i" @click='setSelectPurpose(each.id, each.group_idx)' :style="{ backgroundColor: each.id === selectedPurpose ? 'var(--color-main)' : '#fff' }" class="common_box">
                        <div class="common_text">{{ each.title }}</div>
                    </div>
                </div>
            </div>
            <!-- <div style="margin-top: 32px;">
                <div class="title">기타</div>
                <div class="common_box_wrap">
                    <div v-for="each, i in etc" :key="i + 'etc'" @click='setSelectPurpose(each.id)' :style="{ backgroundColor: each.id === selectedPurpose ? 'var(--color-main)' : '#fff' }" class="common_box">
                        <div class="common_text">{{ each.title }}</div>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>

<script>
import { GROUP_IDX, HOBBY_LIST, LESSON_LIST, COURSE_LIST } from '@/Constants';

export default {
    name: 'SignupPurpose',
    props: {
        selectedPurpose: {
            type: String,
            default: ''
        },
        setSelectPurpose: {
            type: Function,
            default: () => { }
        },
        handlePurposeSelection: {
            type: Function,
            default: () => { }
        },
        purposeList: {
            type: Object,
            default: () => { }
        },
        mode: {
            type: String,
            default: 'insert'
        },
        registInfo: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            hobby: HOBBY_LIST,
            lesson: LESSON_LIST,
            course: COURSE_LIST,
            etc: [
                { title: '👬 멤버 모집하기', id: '멤버 모집하기' },
                { title: '🏟️ 축구팀 찾기', id: '축구팀 찾기' },
                { title: '🙋‍♂️ 축구 질문하기', id: '축구 질문하기' },
                { title: '🙆🏻‍♂️ 포지션 찾기', id: '포지션 찾기' },
            ],
            GROUP_IDX: GROUP_IDX
        }
    },
    methods: {

    },
    created() {

    }
}
</script>

<style scoped>
.title {
    margin-bottom: 16px;
    font-weight: 500;
}

.common_box_wrap {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
}

.common_box {
    padding: 8px;
    border: 1px solid #d9d9d9;
    border-radius: 12px;
}

.common_text {
    font-weight: 500;
    line-height: 24px;
    white-space: nowrap;
}
</style>